import React from "react";
import ReactDOM from "react-dom";
import { BlockEngineApiContext } from "../BlockEngineApi.js";
import { BlockEngineApiFrontend } from "../BlockEngineApiFrontend.js";
import { BlockEngineNode } from "./BlockEngineNode.js";
/**
 * Manage rendering of a page.
 */
export class SmartfireBlockPageRenderer {
    constructor(options = {}) {
        this.root = options.root;
        if (!this.root) {
            // Find the root element
            this.findRoot();
        }
    }
    /**
     * Find on the current page the root element of the page.
     * @returns The root element
     */
    findRoot() {
        const preferredRoot = document.querySelector("smartfire-page-renderer, .smartfire-page-renderer");
        if (preferredRoot) {
            this.root = preferredRoot;
            return this.root;
        }
        // Find all nodes that are smartfire-component or .smartfire-component and choose the uppermost parent that includes all of them
        const smartfireComponentNodes = document.querySelectorAll("smartfire-component, .smartfire-component");
        // Unable to find any smartfire-component or .smartfire-component
        // This is not an error, it just means that the page is not using Smartfire
        if (smartfireComponentNodes.length === 0) {
            return;
        }
        const commonAncestor = this.findCommonAncestor(smartfireComponentNodes);
        if (commonAncestor) {
            return (this.root = commonAncestor);
        }
        // If no common ancestor is found, use the first node
        this.root = smartfireComponentNodes[0];
        return this.root;
    }
    /**
     * Find the common ancestor of the given nodes.
     * @param smartfireComponentNodes List of nodes that are smartfire-component or .smartfire-component
     * @returns Common ancestor of the given nodes or null if no common ancestor is found (happens when the nodes are not in the same tree)
     */
    findCommonAncestor(smartfireComponentNodes) {
        if (smartfireComponentNodes.length < 1) {
            throw new Error("At least one nodes must be provided.");
        }
        const [node1, ...nodes] = Array.from(smartfireComponentNodes);
        let commonAncestor = node1, found = nodes.length === 0;
        do {
            for (let j = 0; j < nodes.length; j++) {
                if (!commonAncestor.contains(nodes[j])) {
                    let parentNode = commonAncestor.parentElement;
                    if (parentNode != null) {
                        commonAncestor = parentNode;
                        break;
                    }
                    else {
                        return null;
                    }
                }
                if (j == nodes.length - 1) {
                    found = true;
                }
            }
        } while (!found);
        return commonAncestor;
    }
    /**
     * Generate the tree of components.
     */
    generateTree() {
        if (!this.root) {
            return;
        }
        const root = new BlockEngineNode({
            node: this.root,
        });
        root.hydrate();
        return root;
    }
    /**
     * Generate React original tree.
     */
    generateReactTree() {
        if (!this.root) {
            throw new Error("Root element not found.");
        }
        const root = this.generateTree();
        const frontendContext = new BlockEngineApiFrontend();
        return [React.createElement(React.StrictMode, {}, React.createElement(BlockEngineApiContext.Provider, {
                value: frontendContext,
            }, root === null || root === void 0 ? void 0 : root.childrenAsReactElements()))];
    }
    /**
     * Render this page manager on the page.
     */
    render() {
        if (!this.root) {
            throw new Error("Root element not found.");
        }
        ReactDOM.render(this.generateReactTree(), this.root);
        console.log("Mounted Smartfire Block Tree on ", this.root);
        return this.root;
    }
}

//# sourceMappingURL=SmartfireBlockPageRenderer.js.map
